export const comics = [
  {
    id: 1,
    title: "绝世神医在都市",
    author: "墨香铜臭",
    category: "都市",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20urban%20Chinese%20manhua%20cover%20featuring%20a%20handsome%20young%20doctor%20in%20white%20coat%20with%20city%20skyline%20background%2C%20warm%20golden%20lighting%2C%20dramatic%20composition%2C%20clean%20illustration%20style%20with%20Chinese%20aesthetic%2C%20soft%20gradients%2C%20minimalist%20design%2C%20bright%20highlights&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    rating: 9.5,
    views: "1280万",
    status: "连载中",
    chapters: 356,
    description: "一代神医重生现代都市，凭借绝世医术逆天改命！医术通天，权财在手，且看他如何搅动风云，成就一段都市传奇！",
    tags: ["热血", "都市", "重生", "爽文"],
    updateTime: "今天 18:00"
  },
  {
    id: 2,
    title: "仙武帝尊",
    author: "百里玺",
    category: "玄幻",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20cover%20showing%20a%20powerful%20martial%20artist%20in%20flowing%20white%20robes%20surrounded%20by%20golden%20energy%20and%20ancient%20temples%2C%20epic%20scale%2C%20warm%20golden%20and%20crimson%20tones%2C%20hand-drawn%20illustration%20style%2C%20clean%20composition%2C%20dramatic%20lighting&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    rating: 9.7,
    views: "2350万",
    status: "连载中",
    chapters: 892,
    description: "少年叶辰，逆天修炼，踏破九霄，成就无上武道至尊！诸天万界，唯我独尊！",
    tags: ["热血", "玄幻", "修仙", "逆袭"],
    updateTime: "今天 12:00"
  },
  {
    id: 3,
    title: "甜心小娇妻",
    author: "苏小暖",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20with%20a%20cute%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20illustration%20style%2C%20gentle%20lighting%2C%20minimalist%20design%2C%20warm%20romantic%20vibe&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    rating: 9.3,
    views: "890万",
    status: "已完结",
    chapters: 180,
    description: "契约婚姻，假戏真做！冷面总裁遇上甜心小娇妻，一场甜蜜又虐心的爱情故事就此展开。",
    tags: ["恋爱", "总裁", "甜宠", "治愈"],
    updateTime: "3天前"
  },
  {
    id: 4,
    title: "末世之黑暗纪元",
    author: "暗夜行者",
    category: "科幻",
    cover: "https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20Chinese%20manhua%20cover%20showing%20a%20lone%20warrior%20in%20dark%20armor%20standing%20in%20a%20ruined%20cityscape%20with%20red%20sky%2C%20dramatic%20moody%20lighting%2C%20warm%20dark%20amber%20tones%2C%20detailed%20illustration%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    rating: 9.6,
    views: "1560万",
    status: "连载中",
    chapters: 520,
    description: "末日降临，丧尸横行。少年觉醒异能，在废墟中建立人类最后的希望之城！",
    tags: ["科幻", "末世", "异能", "热血"],
    updateTime: "今天 20:00"
  },
  {
    id: 5,
    title: "我在古代当首富",
    author: "历史喵",
    category: "穿越",
    cover: "https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20manhua%20cover%20featuring%20a%20cheerful%20young%20merchant%20in%20ancient%20Chinese%20robes%20holding%20gold%20ingots%20in%20a%20bustling%20ancient%20marketplace%2C%20warm%20golden%20and%20red%20tones%2C%20bright%20festive%20atmosphere%2C%20clean%20illustration%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    rating: 9.4,
    views: "720万",
    status: "连载中",
    chapters: 245,
    description: "现代金融精英穿越到古代，用商业头脑打造商业帝国！钱庄、海运、连锁店，且看他如何在古代成为第一首富！",
    tags: ["穿越", "经商", "历史", "爽文"],
    updateTime: "昨天 15:00"
  },
  {
    id: 6,
    title: "妖怪公寓的日常",
    author: "鹿小葵",
    category: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20showing%20cute%20monster%20characters%20in%20a%20modern%20apartment%20setting%2C%20bright%20warm%20colors%2C%20playful%20expressions%2C%20cartoon%20illustration%20style%2C%20cheerful%20atmosphere%2C%20clean%20composition%2C%20soft%20lighting&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    rating: 9.1,
    views: "450万",
    status: "连载中",
    chapters: 168,
    description: "普通大学生误入妖怪公寓，与各路妖怪成为室友的爆笑日常！温馨治愈又笑料百出！",
    tags: ["搞笑", "日常", "治愈", "妖怪"],
    updateTime: "2天前"
  },
  {
    id: 7,
    title: "九幽剑帝",
    author: "剑气长存",
    category: "玄幻",
    cover: "https://readdy.ai/api/search-image?query=A%20sword%20fantasy%20Chinese%20manhua%20cover%20with%20a%20mysterious%20swordsman%20in%20dark%20robes%20holding%20a%20glowing%20ancient%20sword%20against%20a%20mountain%20backdrop%2C%20warm%20golden%20and%20dark%20tones%2C%20epic%20atmosphere%2C%20detailed%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    rating: 9.8,
    views: "3100万",
    status: "连载中",
    chapters: 1200,
    description: "剑道至尊，九幽称帝！一把青锋剑，斩尽世间不公，且看少年一步步登临剑道巅峰！",
    tags: ["热血", "玄幻", "剑道", "逆袭"],
    updateTime: "今天 06:00"
  },
  {
    id: 8,
    title: "总裁大人的小甜心",
    author: "安知晓",
    category: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20office%20Chinese%20manhua%20cover%20showing%20a%20handsome%20CEO%20in%20suit%20and%20a%20sweet%20girl%20in%20modern%20office%20setting%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20romantic%20lighting%2C%20clean%20illustration%20style%2C%20elegant%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    rating: 9.2,
    views: "670万",
    status: "已完结",
    chapters: 200,
    description: "霸道总裁与呆萌秘书的甜蜜爱情故事。他说：你是我的，逃不掉的。",
    tags: ["恋爱", "总裁", "甜宠", "职场"],
    updateTime: "5天前"
  },
  {
    id: 9,
    title: "万界神皇",
    author: "辰东",
    category: "玄幻",
    cover: "https://readdy.ai/api/search-image?query=A%20divine%20Chinese%20manhua%20cover%20featuring%20a%20god-like%20figure%20with%20flowing%20hair%20surrounded%20by%20stars%20and%20galaxies%2C%20cosmic%20scale%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20epic%20fantasy%20illustration%2C%20breathtaking%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    rating: 9.9,
    views: "5600万",
    status: "连载中",
    chapters: 1500,
    description: "诸天万界，神皇独尊！少年从微末中崛起，踏遍三千世界，成就万界至尊神皇之位！",
    tags: ["热血", "玄幻", "诸天", "无敌"],
    updateTime: "今天 10:00"
  },
  {
    id: 10,
    title: "重生之都市修仙",
    author: "十里剑神",
    category: "都市",
    cover: "https://readdy.ai/api/search-image?query=A%20urban%20cultivation%20Chinese%20manhua%20cover%20showing%20a%20young%20man%20with%20mystical%20energy%20in%20a%20modern%20city%20at%20night%2C%20neon%20lights%20and%20ancient%20symbols%2C%20warm%20amber%20and%20teal%20tones%2C%20dynamic%20composition%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    rating: 9.5,
    views: "1890万",
    status: "连载中",
    chapters: 680,
    description: "仙界至尊渡劫失败，重生回到地球都市时代。这一世，他要弥补所有遗憾，踏碎一切阻碍！",
    tags: ["都市", "修仙", "重生", "热血"],
    updateTime: "今天 14:00"
  },
  {
    id: 11,
    title: "神医嫡女",
    author: "杨十六",
    category: "穿越",
    cover: "https://readdy.ai/api/search-image?query=A%20historical%20medical%20Chinese%20manhua%20cover%20featuring%20a%20beautiful%20female%20doctor%20in%20ancient%20Chinese%20dress%20holding%20herbs%2C%20palace%20background%2C%20warm%20soft%20pink%20and%20gold%20tones%2C%20elegant%20illustration%20style%2C%20feminine%20yet%20strong%20vibe&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    rating: 9.4,
    views: "1340万",
    status: "已完结",
    chapters: 320,
    description: "现代女军医穿越成古代庶女，医术超群，逆袭翻身！且看她如何用一身医术，改写命运！",
    tags: ["穿越", "医术", "女强", "逆袭"],
    updateTime: "1周前"
  },
  {
    id: 12,
    title: "超级保安在都市",
    author: "夜独醉",
    category: "都市",
    cover: "https://readdy.ai/api/search-image?query=A%20action%20Chinese%20manhua%20cover%20showing%20a%20cool%20bodyguard%20in%20black%20suit%20with%20sunglasses%20in%20urban%20setting%2C%20warm%20amber%20streetlight%20tones%2C%20cinematic%20style%2C%20dynamic%20pose%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    rating: 9.0,
    views: "560万",
    status: "连载中",
    chapters: 450,
    description: "退役兵王当保安，本想低调过日子，奈何实力不允许！美女环绕，敌人来袭，看超级保安如何笑傲都市！",
    tags: ["都市", "兵王", "热血", "爽文"],
    updateTime: "昨天 20:00"
  }
];

export const categories = [
  { slug: "all", name: "全部" },
  { slug: "xuanhuan", name: "玄幻" },
  { slug: "dushi", name: "都市" },
  { slug: "lianai", name: "恋爱" },
  { slug: "kehuan", name: "科幻" },
  { slug: "chuanyue", name: "穿越" },
  { slug: "gaoxiao", name: "搞笑" },
  { slug: "xianxia", name: "仙侠" },
  { slug: "xuanyi", name: "悬疑" },
  { slug: "rexue", name: "热血" }
];

export const banners = [
  {
    id: 1,
    title: "九幽剑帝",
    subtitle: "全网点击突破3100万！年度最火爆玄幻巨作",
    image: "https://readdy.ai/api/search-image?query=A%20spectacular%20Chinese%20manhua%20banner%20showing%20an%20epic%20swordsman%20in%20flowing%20robes%20against%20a%20breathtaking%20mountain%20landscape%20with%20golden%20divine%20energy%2C%20warm%20golden%20and%20crimson%20dramatic%20lighting%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20illustration&width=1400&height=600&seq=banner-01&orientation=landscape",
    link: "/comic/7"
  },
  {
    id: 2,
    title: "万界神皇",
    subtitle: "诸天万界，神皇独尊！辰东力作持续热更中",
    image: "https://readdy.ai/api/search-image?query=A%20cosmic%20Chinese%20manhua%20banner%20with%20a%20god-like%20figure%20surrounded%20by%20stars%20and%20galaxies%2C%20vast%20universe%20background%2C%20warm%20golden%20and%20deep%20space%20amber%20tones%2C%20epic%20cinematic%20wide%20composition%2C%20breathtaking%20cosmic%20scale&width=1400&height=600&seq=banner-02&orientation=landscape",
    link: "/comic/9"
  },
  {
    id: 3,
    title: "仙武帝尊",
    subtitle: "少年叶辰逆天修炼，踏破九霄成就无上武道",
    image: "https://readdy.ai/api/search-image?query=A%20martial%20arts%20Chinese%20manhua%20banner%20showing%20a%20powerful%20warrior%20in%20white%20robes%20with%20flowing%20energy%20against%20ancient%20temple%20landscape%2C%20warm%20golden%20light%20beams%2C%20epic%20cinematic%20wide%20composition%2C%20dramatic%20and%20heroic%20atmosphere&width=1400&height=600&seq=banner-03&orientation=landscape"
  }
];

export const features = [
  {
    icon: "ri-smartphone-line",
    title: "竖屏下拉式阅读",
    description: "专为手机优化，下滑即可畅读漫画，无需翻页，阅读体验如流水般顺畅"
  },
  {
    icon: "ri-scroll-to-bottom-line",
    title: "无限滚动加载",
    description: "告别翻页等待，章节无缝衔接，一滑到底的沉浸式阅读体验"
  },
  {
    icon: "ri-vip-crown-line",
    title: "免费全集漫画",
    description: "海量热门漫画全部免费阅读，无需付费解锁，全集畅享无限制"
  },
  {
    icon: "ri-fire-line",
    title: "热门漫画一网打尽",
    description: "每日更新热门漫画推荐，玄幻、都市、恋爱、科幻等多元题材全覆盖"
  }
];

export const testimonials = [
  {
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20young%20person%20portrait%20avatar%2C%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20round%20portrait%20style&width=64&height=64&seq=avatar-01&orientation=squarish",
    comment: "甜柚漫画的下拉式阅读真的太好用了！再也不用翻页翻到手酸，一滑就能看完整章，体验超级棒！",
    rating: 5
  },
  {
    name: "追漫达人阿琳",
    avatar: "https://readdy.ai/api/search-image?query=A%20cheerful%20Chinese%20girl%20portrait%20avatar%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20round%20portrait%20style&width=64&height=64&seq=avatar-02&orientation=squarish",
    comment: "免费的！全部免费的！而且漫画资源超级全，热门漫画全都有，追漫党狂喜！",
    rating: 5
  },
  {
    name: "夜猫子读者",
    avatar: "https://readdy.ai/api/search-image?query=A%20cool%20Chinese%20young%20man%20portrait%20avatar%2C%20casual%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20round%20portrait%20style&width=64&height=64&seq=avatar-03&orientation=squarish",
    comment: "每天晚上躺在床上刷漫画，无限滚动太适合夜猫子了，一不小心就看到天亮！",
    rating: 5
  }
];

export const chapterPages = [
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20epic%20martial%20arts%20battle%20scene%20with%20a%20young%20warrior%20wielding%20a%20glowing%20sword%20against%20monsters%2C%20black%20and%20white%20manga%20style%2C%20dynamic%20action%20panels%2C%20speed%20lines%2C%20dramatic%20shading&width=800&height=1200&seq=chapter-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20mysterious%20master%20teaching%20a%20young%20disciple%20in%20an%20ancient%20temple%2C%20black%20and%20white%20manga%20style%2C%20clean%20panel%20layout%2C%20detailed%20background%20art&width=800&height=1200&seq=chapter-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20dramatic%20cliffhanger%20moment%20with%20a%20hero%20falling%20from%20a%20cliff%2C%20black%20and%20white%20manga%20style%2C%20intense%20expressions%2C%20wind%20effects%2C%20cinematic%20composition&width=800&height=1200&seq=chapter-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20hero%20awakening%20hidden%20powers%20with%20explosive%20energy%20burst%2C%20black%20and%20white%20manga%20style%2C%20dynamic%20effects%2C%20transformation%20scene&width=800&height=1200&seq=chapter-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20touching%20reunion%20scene%20between%20two%20characters%2C%20black%20and%20white%20manga%20style%2C%20emotional%20expressions%2C%20soft%20shading%2C%20beautiful%20background&width=800&height=1200&seq=chapter-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20the%20final%20boss%20reveal%20with%20a%20massive%20shadowy%20figure%2C%20black%20and%20white%20manga%20style%2C%20epic%20scale%2C%20dramatic%20contrast&width=800&height=1200&seq=chapter-06&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20victory%20celebration%20scene%20with%20characters%20cheering%2C%20black%20and%20white%20manga%20style%2C%20joyful%20atmosphere%2C%20detailed%20crowd%20scene&width=800&height=1200&seq=chapter-07&orientation=portrait",
  "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20comic%20page%20showing%20a%20mysterious%20new%20character%20introduction%20with%20dramatic%20entrance%2C%20black%20and%20white%20manga%20style%2C%20silhouette%20reveal%2C%20atmospheric%20shading&width=800&height=1200&seq=chapter-08&orientation=portrait"
];